import cookie from 'cookie';
import get from 'lodash.get';
import {EU_SITE_COOKIE_NAME, CCPA_STATE_COOKIE_NAME, ADS_REFRESH_EVENT} from '../constants';

export const onDestinationChange = (gaiaId) => {
    if (window.meso && window.meso.targeting) {
        // If gaid id missed we send empty string to show generic ads. Temporary solution.
        // Refereed to VLX-6493
        window.meso.targeting.push({adinfo: {dest: gaiaId || ''}});
    }
};

export const onPageUpdate = () => {
    if (typeof window.CustomEvent === 'function') {
        document.dispatchEvent(new CustomEvent(ADS_REFRESH_EVENT));
    } else {
        // IE11 fallback for custom events
        const customEvent = document.createEvent('CustomEvent');
        customEvent.initCustomEvent(ADS_REFRESH_EVENT, true, true, {});
        document.dispatchEvent(customEvent);
    }
};

export const onAdsContextInit = ({brandId, locale, havId, gaiaId}) => {
    window.meso = window.meso || {};
    window.meso.logging = window.meso.logging || [];
    window.meso.targeting = window.meso.targeting || [];
    window.meso.initialize = window.meso.initialize || [];

    const cookies = cookie.parse(document.cookie);
    const isEU = cookies[EU_SITE_COOKIE_NAME] === '1';
    const canSell = !(cookies[CCPA_STATE_COOKIE_NAME] === 'true');

    const gdpr = get(window, 'cookieconsent.gdpr', null);
    const pageId = get(window, 'analyticsdatalayer.pagetype', 'search');

    if (window.meso.logging.length === 0) {
        window.meso.logging.push(`Adblock: ${window.adblock}`);
    }

    document.cookie = cookie.serialize('DUAID', havId);

    window.meso.initialize.push({
        pageId,
        type: 'target',
        siteId: brandId,
        variant: 'default',
        locale: locale && locale.replace('-', '_'),
        canTrack: isEU ? !!(gdpr && gdpr.hasConsented()) : true,
        canSell
    });

    onDestinationChange(gaiaId);
};
